import globals from '../common/globals';
import loadScript from '../lib/loadScript';

export async function loadGoogleMaps() {
   const key = process.env.GOOGLE_WEB_API;
   const src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&language=en`;

   await loadScript(src);
}

export async function initStripeV3() {
   if (globals.stripe) return;

   await loadScript('https://js.stripe.com/v3/');
   globals.stripe = window.Stripe(process.env.STRIPE);
}

export async function initStripeV2() {
   if (window.Stripe) return;

   await loadScript('https://js.stripe.com/v2/');
   window.Stripe.setPublishableKey(process.env.STRIPE);
}

export function logMessage(message) {
   if (process.env.SENTRY && window.Sentry) {
      window.Sentry.captureMessage(message);
   }
}

export function prepareGAEventInfo(eventCategory, eventAction, eventLabel) {
   return { eventCategory, eventAction, eventLabel };
}

export function sendGA(operation, name, value) {
   if (!window.ga) return;

   window.ga(operation, name, value);
}

export function logJSError(errorObj) {
   if (process.env.SENTRY && window.Sentry) {
      if (errorObj && {}.hasOwnProperty.call(errorObj, 'message')) {
         errorObj.message = 'Processed error: ' + errorObj.message;
      }
      window.Sentry.captureException(errorObj);
   }
}